export const bgColor = [
  "#2A848E",
  "#FED425",
  "#FD934F",
  "#FA505E",
]